export const EVENT_CHANNEL = 'navigation';
export const COMPONENT_NAME = 'GlobalSideNavigation';
export const ATLASKIT_CHANNEL = 'atlaskit';
